import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ValidationTypes } from '../models/meta-data.model';

@Directive({
  selector: '[lowyOnlyDigits]'
})
export class OnlyDigitsDirective {

  constructor(private el: ElementRef) { }

  @Input() lowyOnlyDigits: ValidationTypes;

  @HostListener('keydown', ['$event']) onKeyDown(event) {

    const e = <KeyboardEvent> event;
    if ([16, 8, 46, 9].includes(e.keyCode)) {
      return; // shift, backspace, delete, tab
    }
    if (this.lowyOnlyDigits) {
      // digits or numpad digits
      if (((e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {

        if ([ValidationTypes.threeDigitsDecimal, ValidationTypes.threeDigitsDecimalMax10, ValidationTypes.threeDigitsDecimalMax10orTripleDigits]
          .includes(this.lowyOnlyDigits)) {
          // allow decimal
          if (!(e.keyCode === 190 || e.keyCode === 110)) {
            e.preventDefault();
          }
        }
        else {
          e.preventDefault();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/only-digits.directive.ts